export default __webpack_public_path__ + "static/polozhenie_o_pedsovete_ecp-585908f0e54b0dcc5b06a3ff7ec11812.pdf";